export default "__VITE_PUBLIC_ASSET__af76467f__"